import React from 'react';
import styled from 'styled-components';
import { IAction } from '../../../ui/dialog/Dialog';
import CommonSection from '../commonSection/CommonSection';
import SectionTitle from '../sectionTitle/SectionTitle';
import { ActionDialog } from '../ActionDialog/ActionDialog';

// tslint:disable-next-line:variable-name
const STitle = styled.h1(
  ({ theme }) => `
  font-weight: ${theme.font.weight.normal};
  color: ${theme.colors.dark};
  font-size: ${theme.font.size.medium3};
  @media only screen and ${theme.device.laptopS} {
    font-size: ${theme.font.size.mediumLarge};
  }
`
);

// tslint:disable-next-line:variable-name
const SSectionTitle = styled(SectionTitle)(
  ({ theme }) => `
  @media only screen and ${theme.device.laptopS} {
    font-size: ${theme.font.size.medium};
  }
`
);

// tslint:disable-next-line:no-empty-interface
interface IOutOfRangeIncomeDialogProps {
  actionList: IAction[];
  onCloseAction?: VoidFunction;
}

// tslint:disable-next-line:variable-name
const BeforeExitDialog: React.FC<IOutOfRangeIncomeDialogProps> = ({ actionList, onCloseAction }) => {
  return (
    <ActionDialog actionList={actionList} onCloseAction={onCloseAction}>
      <CommonSection>
        <STitle>Are you sure you want to exit the application?</STitle>
      </CommonSection>
      <CommonSection>
        <SSectionTitle data-at="fullSsnRequiredSubtitle">If you exit the application your information will not be saved.</SSectionTitle>
      </CommonSection>
    </ActionDialog>
  );
};

export default BeforeExitDialog;
